'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/GlobalModals/ModalInfo.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sureComponents = require('sure-components');

var _Button = require('shared/lib/components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  title: _propTypes2.default.string,
  btnText: _propTypes2.default.string,
  body: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  isHtml: _propTypes2.default.bool,
  afterDismiss: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func,
  afterConfirm: _propTypes2.default.func
};

var ModalInfo = function (_PureComponent) {
  _inherits(ModalInfo, _PureComponent);

  function ModalInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalInfo.__proto__ || Object.getPrototypeOf(ModalInfo)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function () {
      _this.props.onDismiss();

      if ((0, _isFunction2.default)(_this.props.afterDismiss)) {
        _this.props.afterDismiss();
      }
    }, _this.handleConfirm = function () {
      _this.props.onDismiss();

      if ((0, _isFunction2.default)(_this.props.afterConfirm)) {
        _this.props.afterConfirm();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          btnText = _props.btnText,
          sureStyle = _props.sureStyle;
      return _react2.default.createElement(_sureComponents.Modal, {
        title: title || 'Info',
        isActive: true,
        onDismiss: this.handleDismiss,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        },
        __self: this
      }, this.bodyNode, _react2.default.createElement(_Button2.default, {
        onClick: this.props.afterConfirm ? this.handleConfirm : this.handleDismiss,
        sureStyle: sureStyle,
        style: {
          marginBottom: 0
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        },
        __self: this
      }, btnText || 'Ok'));
    }
  }, {
    key: 'bodyNode',
    get: function get() {
      var _props2 = this.props,
          body = _props2.body,
          isHtml = _props2.isHtml;

      if ((0, _isString2.default)(body)) {
        if (isHtml) {
          return _react2.default.createElement('div', {
            dangerouslySetInnerHTML: {
              __html: body
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 38
            },
            __self: this
          });
        } else {
          return _react2.default.createElement('p', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            },
            __self: this
          }, body);
        }
      } else if (_react2.default.isValidElement(body)) {
        return body;
      } else {
        return null;
      }
    }
  }]);

  return ModalInfo;
}(_react.PureComponent);

ModalInfo.propTypes = propTypes;
exports.default = ModalInfo;